var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167232",
    "data-name": "Group 167232",
    transform: "translate(-2690 -1094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(2692 1096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M6.5-1A7.5,7.5,0,1,1-1,6.5,7.508,7.508,0,0,1,6.5-1Zm0,13A5.5,5.5,0,1,0,1,6.5,5.506,5.506,0,0,0,6.5,12Z",
    transform: "translate(3 3)",
    fill: "#636974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_304",
    "data-name": "Line 304",
    d: "M3.611,4.611A1,1,0,0,1,2.9,4.318L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L4.318,2.9a1,1,0,0,1-.707,1.707Z",
    transform: "translate(14.331 14.331)",
    fill: "#636974"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.8764222b15e6443d0e91cbf9700f43a1.svg";
export { ForwardRef as ReactComponent };